import React from "react"

import { DemandRequestOverlay } from "./DemandRequestOverlay"
import { useDemandRequestOverlayModel } from "./hooks/useDemandRequestOverlayModel"

export const DemandRequestOverlayConnector = React.memo(() => {
  return <DemandRequestOverlay {...useDemandRequestOverlayModel()} />
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DEMAND_REQUEST_OVERLAY: null
  }
}
